module.exports = __webpack_public_path__ + "static/media/pemira-ttd.606f7fbd.svg";